import { EntityId } from "@jackfruit/common"
import { chunk } from "lodash"
import { useLineItem } from "~/hooks/useLineItem"
import { useProductPages } from "~/hooks/useProductPages"
import { PageType, ProductPageEntity } from "~/interfaces/entities/ProductPage"

export const usePhotoBookPages = (lineItemId: EntityId) => {
  const { lineItem } = useLineItem(lineItemId)
  const { productPageIds } = lineItem
  const { productPages } = useProductPages(productPageIds)

  const frontCoverPage = productPages.find(
    page => page.pageType === PageType.FrontCover
  )

  const frontCoverInsidePage = productPages.find(
    page => page.pageType === PageType.FrontCoverInside
  )

  const insidePages = productPages.filter(
    page => page.pageType === PageType.Page || page.pageType === undefined
  )

  const backCoverInsidePage = productPages.find(
    page => page.pageType === PageType.BackCoverInside
  )

  const insidePagesAndCover = [
    frontCoverInsidePage,
    ...insidePages,
    backCoverInsidePage,
  ].filter(Boolean) as ProductPageEntity[]

  const allPages = [frontCoverPage, ...insidePagesAndCover].filter(
    Boolean
  ) as ProductPageEntity[]

  const spreads = chunk(insidePagesAndCover, 2)

  return {
    allPages,
    frontCoverPage,
    frontCoverInsidePage,
    insidePages,
    insidePagesAndCover,
    backCoverInsidePage,
    spreads,
  }
}
